interface IAccountPositions {
  position?: { id: number } | null;
  targetPosition?: { id: number } | null;
}

const getDevelopmentPositionId = (account: IAccountPositions): number | null =>
  account.targetPosition?.id ?? account.position?.id ?? null;

export { getDevelopmentPositionId };
